import styled from 'styled-components'
import { Statistic as AntdStatistic } from 'antd'
import { Card as CardComponent } from 'src/components/Ant'

export const Card = styled(CardComponent)`
  margin-bottom: 16px;
`

export const Statistic = styled(AntdStatistic)`
  text-align: center;
  min-height: 5rem;
  .ant-statistic-title {
    min-height: 2.5rem;
  }
`
